import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./TimelineStyles";
import SelectMenu from "./SelectMenu";
import { activityActions, energyActions } from "../_actions";
import { styles as selectStyles } from "./SelectMenuStyles";
import moment from "moment";
import { connect } from "react-redux";
import { appliancesConstants } from "../_constants";

class Timeline extends Component {
  render() {
    const detail = this.props;
    let optionArray = [];
    let momentFormat = "dddd Do MMMM";

    if (detail.available && detail.available.length > 0) {
      for (var i = detail.available.length - 1; i >= 0; i--) {
        optionArray.push(
          <option key={`selectItem${i}`} value={detail.available[i]}>
            {moment.unix(detail.available[i]).format(momentFormat)}
          </option>
        );
      }
    }

    let TimelineItem = props => {
      return (
        <li className={css(styles.listItem)}>
          <a
            href={`/my-home/appliance/${props.appliance_type_id}`}
            className={css(styles.item)}
          >
            <div className={css(styles.itemLeft)}>
              <img className={css(styles.icon)} src={props.icon} alt="" />
              <strong className={css(styles.title)}>{props.name}</strong>
            </div>
            <span className={css(styles.time)}>
              {moment.unix(props.start_timestamp).format("h:mma")}
            </span>
          </a>
        </li>
      );
    };
    return (
      <div>
        <div className={css(selectStyles.selectWrapper)}>
          <select
            className={css(selectStyles.select)}
            value={this.props.energy.detailItem}
            onChange={e => {
              const timestamp = e.target.value;
              this.props.dispatch(energyActions.setDetailItem(timestamp));
              this.props.dispatch(
                energyActions.getTimeline(
                  this.props.authentication.user.user_id,
                  timestamp
                )
              );
            }}
          >
            {optionArray}
          </select>
          <span className={css(selectStyles.arrow)}>
            <span className={css(selectStyles.changeText)}>{"Change day"}</span>
          </span>
        </div>
        <div className={css(styles.timeSelectWrapper)}>
          <button
            className={css(styles.timeButton)}
            disabled={detail.previous == null ? true : false}
            onClick={e => {
              const timestamp = detail.previous;
              this.props.dispatch(energyActions.setDetailItem(timestamp));
              this.props.dispatch(
                energyActions.getTimeline(
                  this.props.authentication.user.user_id,
                  timestamp
                )
              );
            }}
          >
            <img
              className={css(styles.timeButtonIcon)}
              src={"/icons/previous.svg"}
            />
            {"Previous day"}
          </button>{" "}
          <button
            className={css(styles.timeButton)}
            disabled={detail.next == null ? true : false}
            onClick={e => {
              const timestamp = detail.next;
              this.props.dispatch(energyActions.setDetailItem(timestamp));
              this.props.dispatch(
                energyActions.getTimeline(
                  this.props.authentication.user.dependant_user_id,
                  timestamp
                )
              );
            }}
          >
            {"Next day"}
            <img
              className={css(styles.timeButtonIconRight)}
              src={"/icons/next.svg"}
            />
          </button>
        </div>

        <ul className={css(styles.list)}>
          {this.props.events && this.props.events.length === 0 && (
            <h3 className={css(styles.notUsed)}>
              No appliances used during this period
            </h3>
          )}
          {this.props.events &&
            this.props.events.map((item, i) => {
              return <TimelineItem {...item} />;
            })}
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const authentication = state.authentication;
  const dispatch = state.dispatch;
  const activity = state.activity;
  const energy = state.energy;
  return {
    authentication,
    dispatch,
    activity,
    energy
  };
}

export default connect(mapStateToProps)(Timeline);
